/* unplugin-vue-components disabled */import "core-js/modules/es.array.join.js";
import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue';
import { unref as _unref, resolveComponent as _resolveComponent, isRef as _isRef, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
import dayjs from 'dayjs';
import Popup from './Popup.vue';
import useDatePicker from './hook';
import { CHAR, DAYJS_FORMAT } from '@/config/common';
export default /*#__PURE__*/_defineComponent({
  __name: 'PikerUserDefined',
  props: /*#__PURE__*/_mergeModels({
    data: {},
    timeType: {}
  }, {
    "modelValue": {},
    "modelModifiers": {}
  }),
  emits: /*#__PURE__*/_mergeModels(["confirm-user-defined"], ["update:modelValue"]),
  setup: function setup(__props, _ref) {
    var __emit = _ref.emit;
    var props = __props;
    var _toRefs = toRefs(props),
      data = _toRefs.data,
      timeType = _toRefs.timeType;
    var emit = __emit;
    var _useDatePicker = useDatePicker(),
      zeroFill = _useDatePicker.zeroFill,
      titleTabs = _useDatePicker.titleTabs,
      visibleOptionNum = _useDatePicker.visibleOptionNum;
    var model = _useModel(__props, "modelValue");
    var tabs = ['选择日期', '选择时间'];
    var currentDateValue = ref([]);
    var currentTimeValue = ref([]);
    var columnsType = ['hour', 'minute', 'second'];
    // const maxTime = ref(dayjs().format(DAYJS_FORMAT.HHMMSS));
    var title = computed(function () {
      return titleTabs[timeType.value];
    });
    var maxTime = computed(function () {
      var currentDateStr = _.join(currentDateValue.value, CHAR.DASH);
      var dayjsValue = dayjs(currentDateStr);
      if (dayjsValue.isToday()) {
        return dayjs().format(DAYJS_FORMAT.HHMMSS);
      } else return dayjs().endOf('day').format(DAYJS_FORMAT.HHMMSS);
    });
    watch(model, function () {
      return setTimeout(currentValueSync);
    });
    watch(data, currentValueSync, {
      deep: true,
      immediate: true
    });
    function onCancel() {
      model.value = false;
      console.log('isToday=>', dayjs('2024-11-01').isToday());
    }
    function onConfirm(options) {
      model.value = false;
      emit('confirm-user-defined', {
        options: options,
        timeType: timeType.value
      });
    }
    function formatterDate(type, option) {
      if (type === 'year') {
        option.text += '年';
      }
      if (type === 'month') {
        option.text += '月';
      }
      if (type === 'day') {
        option.text += '日';
      }
      return option;
    }
    function formatterTime(type, option) {
      if (type === 'hour') {
        option.text += '时';
      }
      if (type === 'minute') {
        option.text += '分';
      }
      if (type === 'second') {
        option.text += '秒';
      }
      return option;
    }
    function currentValueSync() {
      var dayjsValue = data.value[timeType.value].clone();
      // 年
      var year = dayjsValue.year();
      // 月
      var month = dayjsValue.month();
      var monthValue = zeroFill(_.add(month, 1));
      // 日
      var d = dayjsValue.date();
      var dValue = zeroFill(d);
      // 时
      var h = dayjsValue.hour();
      var hValue = zeroFill(h);
      // 分
      var m = dayjsValue.minute();
      var mValue = zeroFill(m);
      // 秒
      var s = dayjsValue.second();
      var sValue = zeroFill(s);
      currentDateValue.value = [String(year), monthValue, dValue];
      currentTimeValue.value = [hValue, mValue, sValue];
    }
    return function (_ctx, _cache) {
      var _component_van_date_picker = _resolveComponent("van-date-picker");
      var _component_van_time_picker = _resolveComponent("van-time-picker");
      var _component_van_picker_group = _resolveComponent("van-picker-group");
      return _openBlock(), _createBlock(Popup, {
        modelValue: model.value,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = function ($event) {
          return model.value = $event;
        })
      }, {
        default: _withCtx(function () {
          return [_createVNode(_component_van_picker_group, {
            tabs: tabs,
            title: _unref(title),
            onCancel: onCancel,
            onConfirm: onConfirm
          }, {
            default: _withCtx(function () {
              return [_createVNode(_component_van_date_picker, {
                "max-date": new Date(),
                modelValue: _unref(currentDateValue),
                "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) {
                  return _isRef(currentDateValue) ? currentDateValue.value = $event : null;
                }),
                formatter: formatterDate,
                "visible-option-num": _unref(visibleOptionNum)
              }, null, 8, ["max-date", "modelValue", "visible-option-num"]), _createVNode(_component_van_time_picker, {
                "max-time": _unref(maxTime),
                formatter: formatterTime,
                modelValue: _unref(currentTimeValue),
                "onUpdate:modelValue": _cache[1] || (_cache[1] = function ($event) {
                  return _isRef(currentTimeValue) ? currentTimeValue.value = $event : null;
                }),
                "columns-type": columnsType,
                "visible-option-num": _unref(visibleOptionNum)
              }, null, 8, ["max-time", "modelValue", "visible-option-num"])];
            }),
            _: 1
          }, 8, ["title"])];
        }),
        _: 1
      }, 8, ["modelValue"]);
    };
  }
});